// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3ZDqJ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2TpNL"};